// ─────────────────────────────────────────────────────────────────────────────
// Notifications tab — workspace alert-delivery preferences.
// Wired to GET/PUT /settings/notifications. Data + save live in
// useNotificationSettings; this component registers that save fn on `saveRef`
// so the header's Save Changes button can invoke it (same pattern as
// CompanyProfile). These toggles gate which notification categories the backend
// generates and pushes.
// ─────────────────────────────────────────────────────────────────────────────
import { useEffect } from "react";
import panes from "./panes.module.css";
import { useNotificationSettings } from "../hooks/useNotificationSettings";
import { ALERT_PREFS } from "../../../services/settingsService";
import { SectionTitle, Toggle, ToggleList, LoadingPane, ErrorBanner } from "./fields";

export default function Notifications({ saveRef, readOnly = false }) {
  const { prefs, loading, error, toggle, save } = useNotificationSettings();

  // Hand the save fn up to the page (the Save button lives in the header).
  useEffect(() => {
    if (saveRef) saveRef.current = save;
  }, [save, saveRef]);

  if (loading) return <LoadingPane/>;
  if (!prefs)  return <ErrorBanner>{error || "Failed to load notification preferences."}</ErrorBanner>;

  return (
    <div className={panes.pane}>
      {error && <ErrorBanner>{error}</ErrorBanner>}

      <SectionTitle>Alert Preferences</SectionTitle>

      <ToggleList>
        {ALERT_PREFS.map(({ key, label, sub }) => (
          <Toggle
            key={key} label={label} sub={sub}
            checked={!!prefs[key]}
            onChange={toggle(key)}
            disabled={readOnly}
          />
        ))}
      </ToggleList>
    </div>
  );
}
